module.exports = __webpack_public_path__ + "img/icon01.016c6280.svg";